import { render, staticRenderFns } from "./Splitter.vue?vue&type=template&id=54217166&scoped=true"
import script from "./Splitter.vue?vue&type=script&lang=js"
export * from "./Splitter.vue?vue&type=script&lang=js"
import style0 from "./Splitter.vue?vue&type=style&index=0&id=54217166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54217166",
  null
  
)

export default component.exports